import React from "react";
import { HiArrowRight } from "react-icons/hi";

const Card = ({ title, des, icon }) => {
  return (
    <div
      className="
        w-full px-12 h-80 py-10
        rounded-lg
        shadow-shadowOne
        flex items-center
        bg-gradient-to-r from-bodyColor to-[#202327]
        border border-gray-800
        hover:border-designColor
        hover:-translate-y-1
        transition-all duration-300
        group
      "
    >
      <div className="flex flex-col gap-6">
        
        {/* Icon */}
        {icon && (
          <span className="
            text-5xl text-designColor
            transition-transform duration-300
            group-hover:scale-110
          ">
            {icon}
          </span>
        )}

        {/* Title */}
        <h2 className="text-xl md:text-2xl font-titleFont font-bold text-gray-300">
          {title}
        </h2>

        {/* Description */}
        <p className="text-gray-400 group-hover:text-gray-200 transition-colors duration-300">
          {des}
        </p>

        {/* Arrow */}
        <span className="
          text-2xl text-designColor
          transition-transform duration-300
          group-hover:translate-x-1
        ">
          <HiArrowRight />
        </span>
      </div>
    </div>
  );
};

export default Card;
